export default __webpack_public_path__ + "static/media/x.4fbe63c1.svg";